angular.module('app.directives.schedule').directive('twitterSimulcastSettings', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '=',
    },
    template: require('./twitter-simulcast-settings.html'),
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/twitter-simulcast-settings.js